module.exports = __webpack_public_path__ + "img/appAsset--pdf-ax.575935e5.svg";